module.exports = __webpack_public_path__ + "static/img/gift-title.6ec7fe33.png";